import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { ChecklistsDashboardPage } from '@/pages/checklists/checklists-dashboard'

import * as S from './inspections.styled'
import { ClientProfileInspectionsProps } from './inspections.types'

export const Inspections = ({ clientId }: ClientProfileInspectionsProps) => {
  const { data: clientData, isLoading } = useGetClientProfile({ clientId })

  if (isLoading || !clientData) return null

  const resident = {
    apartment: clientData.apartment,
    buildingNumber: clientData.buildingNumber,
    id: Number(clientId),
    name: `${clientData.user.firstName} ${clientData.user.lastName}`,
  }

  return (
    <S.Container>
      <ChecklistsDashboardPage resident={resident} building={clientData.buildingId} />
    </S.Container>
  )
}
